// Fun adjectives for nickname generation
const adjectives = [
  'Happy', 'Clever', 'Bright', 'Swift', 'Bold', 'Brave', 'Calm', 'Wise',
  'Kind', 'Gentle', 'Fierce', 'Noble', 'Quick', 'Silent', 'Mighty', 'Cosmic',
  'Stellar', 'Electric', 'Peaceful', 'Cheerful', 'Daring', 'Graceful', 'Radiant',
  'Vivid', 'Zealous', 'Curious', 'Eager', 'Fearless', 'Honest', 'Jolly',
  'Lucky', 'Nimble', 'Proud', 'Serene', 'Witty', 'Zealous', 'Artistic',
  'Creative', 'Dynamic', 'Energetic', 'Friendly', 'Generous', 'Humble',
];

// Fun nouns for nickname generation
const nouns = [
  'Penguin', 'Dragon', 'Phoenix', 'Tiger', 'Eagle', 'Wolf', 'Bear', 'Fox',
  'Panda', 'Koala', 'Dolphin', 'Falcon', 'Hawk', 'Lion', 'Owl', 'Raven',
  'Shark', 'Whale', 'Otter', 'Raccoon', 'Squirrel', 'Hedgehog', 'Rabbit',
  'Turtle', 'Butterfly', 'Hummingbird', 'Sparrow', 'Robin', 'Starling',
  'Swan', 'Pelican', 'Flamingo', 'Cheetah', 'Leopard', 'Jaguar', 'Lynx',
  'Panther', 'Cougar', 'Badger', 'Beaver', 'Moose', 'Deer', 'Elk',
];

/**
 * Generates a random nickname in the format "Adjective Noun"
 * Example: "Happy Penguin", "Swift Dragon", "Brave Tiger"
 */
export function generateNickname(): string {
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  return `${adjective} ${noun}`;
}

/**
 * Gets initials from a nickname
 * Example: "Happy Penguin" -> "HP"
 */
export function getNicknameInitials(nickname: string): string {
  const words = nickname.split(' ');
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  return nickname.slice(0, 2).toUpperCase();
}
